import { render, staticRenderFns } from "./PageBreadcrumbs.vue?vue&type=template&id=1975b748"
import script from "./PageBreadcrumbs.vue?vue&type=script&lang=ts"
export * from "./PageBreadcrumbs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports